import React from 'react'
import Digital from './DigitalWizards/Digital'

const DigitalWizards = () => {
  return (
    <Digital />
  )
}

export default DigitalWizards